export default "__VITE_ASSET__DhiD1M96__"